import AppLayout from "../AppLayout";
import Login from "../features/Auth/Login";
import Logout from "../features/Auth/Logout";

export const routes = [
  { key: "login", path: "/login", element: <Login /> },
  { key: "layout", path: "/*", element: <AppLayout />, private: true },
  { key: "logout", path: "/logout", element: <Logout /> },
];
